export enum LegalDocumentStatusEnum {
    New = 1,
    OnReview = 2,
    Active = 3,
    Expired = 4,
    Rejected = 5
}
